import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import api from "../../api";
import { getMiningLevel, getCatcherLevel, getLevel } from "../../constants/items";
import jwt_decode from "jwt-decode";

const PlayerStats = () => {
  const [rankings, setRankings] = useState(null);
  const [profile, setProfile] = useState(null);
  
  // Get username from JWT token
  const getUsername = () => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      try {
        const decoded = jwt_decode(token);
        return decoded.sub || decoded.username;
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
    return localStorage.getItem("authUser");
  };
  
  const username = getUsername();

  useEffect(() => {
    api
      .get("/v1/profile", { withCredentials: true })
      .then((response) => {
        setProfile(response.data);
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
      });
  }, []);

  useEffect(() => {
    api
      .get(`/v1/leaderboard/rankings?username=${username}`, {
        withCredentials: true,
      })
      .then((res) => {
        const dataToStore = { data: res.data, timestamp: Date.now() };
        localStorage.setItem("leaderboardData", JSON.stringify(dataToStore));
        setRankings(res.data);
      })
      .catch((err) => console.error("Error fetching rankings:", err));
  }, [username]);

  if (!profile) {
    return <div>Loading Profile...</div>;
  }

  const getOrdinalRank = (rank) => {
    const j = rank % 10,
      k = rank % 100;
    if (j === 1 && k !== 11) return `${rank}st`;
    if (j === 2 && k !== 12) return `${rank}nd`;
    if (j === 3 && k !== 13) return `${rank}rd`;
    return `${rank}th`;
  };

  const getAwardImage = (rank) => {
    if (rank === 1) {
      return (
        <span>
          <img
            src="/items/1st.png"
            alt="1st Award"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "0.5rem",
            }}
          />
        </span>
      );
    } else if (rank === 2) {
      return (
        <span>
          <img
            src="/items/2nd.png"
            alt="2nd Award"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "0.5rem",
            }}
          />
        </span>
      );
    } else if (rank === 3) {
      return (
        <span>
          <img
            src="/items/3rd.png"
            alt="3rd Award"
            style={{
              width: "24px",
              verticalAlign: "middle",
              marginLeft: "0.5rem",
            }}
          />
        </span>
      );
    }
    return null;
  };

  return (
    <Card
      style={{
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
        marginBottom: "1.5rem",
        border: "none",
        overflow: "hidden"
      }}
    >
      <CardBody 
        style={{
          padding: "1.5rem",
          backgroundColor: "#1d222e",
          color: "#ffffff"
        }}
        className="rounded">
        <Row className="align-items-center">
          <Col md="2" className="text-center">
            <img
              src={`/avatars/${profile?.avatar}.png`}
              alt="Avatar"
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                objectFit: "cover",
                marginBottom: "1rem",
              }}
            />
          </Col>

          <Col md="10">
            <div className="mb-3">
              {(() => {
                const staffRoles = {
                  'Brokeboy': 'Developer',
                  'ZigCiguzo': 'Developer', 
                  'JoeD2Cold': 'Moderator',
                  'EmoNovember': 'Admin'
                };
                
                const userRole = staffRoles[profile.username];
                
                return (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                    <h4 className="mb-0" style={{ color: "#ffffff", fontWeight: "600" }}>{profile.username}</h4>
                    <span style={{
                      backgroundColor: userRole ? (
                        userRole === 'Developer' ? '#E91E63' : 
                        userRole === 'Admin' ? '#FF5722' : '#9C27B0'
                      ) : '#6c757d',
                      color: '#fff',
                      padding: '4px 12px',
                      borderRadius: '16px',
                      fontSize: '0.75rem',
                      fontWeight: '600',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                    }}>
                      {userRole || 'Trainer'}
                    </span>
                  </div>
                );
              })()}
            </div>

            <div className="mb-3">
              <div
                style={{
                  background: "linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.02) 100%)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  borderRadius: "8px",
                  padding: "10px 14px",
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  gap: "16px"
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <img src="/items/coin.png" alt="coin" style={{ width: "20px", height: "20px" }} />
                  <strong style={{ color: "#eab308" }}>{profile.coins.toLocaleString()}</strong>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <img src="/items/battle_coin.png" alt="battle coin" style={{ width: "20px", height: "20px" }} />
                  <strong style={{ color: "#ffffff" }}>{profile.battle_coins.toLocaleString()}</strong>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <img src="/items/money.png" alt="money" style={{ width: "20px", height: "20px" }} />
                  <strong style={{ color: "#22c55e" }}>{profile.money.toLocaleString()}</strong>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <img src="/items/pokedex.png" alt="pokedex" style={{ width: "20px", height: "20px" }} />
                  <span style={{ color: "#3b82f6", fontWeight: "600" }}>{profile.pokedex_count.toLocaleString()} Species</span>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                  gap: "10px"
                }}
              >
                {/* Trainer Level */}
                <div style={{
                  background: "linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(220, 38, 38, 0.05) 100%)",
                  border: "1px solid rgba(239, 68, 68, 0.3)",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.2s ease",
                  cursor: "default"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
                >
                  <img
                    src="/items/battleseek.png"
                    alt="trainer level"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                    <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Trainer</span>
                    <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#ef4444" }}>Lv. {getLevel(profile.exp).toLocaleString()}</span>
                  </div>
                </div>

                {/* Catcher Level */}
                <div style={{
                  background: "linear-gradient(135deg, rgba(34, 197, 94, 0.15) 0%, rgba(22, 163, 74, 0.05) 100%)",
                  border: "1px solid rgba(34, 197, 94, 0.3)",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.2s ease",
                  cursor: "default"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(34, 197, 94, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
                >
                  <img
                    src="/items/pokeball.png"
                    alt="catcher level"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                    <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Catcher</span>
                    <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#22c55e" }}>Lv. {getCatcherLevel(profile.catcher_exp).toLocaleString()}</span>
                  </div>
                </div>

                {/* Mining Level */}
                <div style={{
                  background: "linear-gradient(135deg, rgba(161, 98, 7, 0.15) 0%, rgba(120, 53, 15, 0.05) 100%)",
                  border: "1px solid rgba(161, 98, 7, 0.3)",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.2s ease",
                  cursor: "default"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(161, 98, 7, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
                >
                  <img
                    src="/items/NormalPickaxe.png"
                    alt="mining level"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                    <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Mining</span>
                    <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#d97706" }}>Lv. {getMiningLevel(profile.miningexp).toLocaleString()}</span>
                  </div>
                </div>

                {/* Fishing Level */}
                <div style={{
                  background: "linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.05) 100%)",
                  border: "1px solid rgba(59, 130, 246, 0.3)",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.2s ease",
                  cursor: "default"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
                >
                  <img
                    src="/items/superrod.png"
                    alt="fishing level"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                    <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Fishing</span>
                    <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#3b82f6" }}>Lv. {getMiningLevel(profile.fishingexp).toLocaleString()}</span>
                  </div>
                </div>

                {/* Farming Level */}
                <div style={{
                  background: "linear-gradient(135deg, rgba(251, 146, 60, 0.15) 0%, rgba(249, 115, 22, 0.05) 100%)",
                  border: "1px solid rgba(251, 146, 60, 0.3)",
                  borderRadius: "8px",
                  padding: "8px 12px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.2s ease",
                  cursor: "default"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(251, 146, 60, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
                >
                  <img
                    src="/items/razzberry.png"
                    alt="farming level"
                    style={{ width: "24px", height: "24px" }}
                  />
                  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                    <span style={{ fontSize: "0.7rem", color: "rgba(255, 255, 255, 0.6)", textTransform: "uppercase", fontWeight: "600" }}>Farming</span>
                    <span style={{ fontSize: "0.95rem", fontWeight: "700", color: "#fb923c" }}>Lv. {getMiningLevel(profile.farmingexp).toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>

            {rankings ? (
              <div className="mt-4" style={{
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                borderRadius: "8px",
                padding: "1rem",
                border: "1px solid rgba(255, 255, 255, 0.1)"
              }}>
                <h5 className="mb-3" style={{ color: "#ffffff", fontWeight: "600" }}>Leaderboard Rankings</h5>
                <Row>
                  <Col md="4">
                    Trainer:{" "}
                    {rankings.trainer.rank <= 3
                      ? getAwardImage(rankings.trainer.rank)
                      : getOrdinalRank(rankings.trainer.rank)}
                  </Col>
                  <Col md="4">
                    Catcher:{" "}
                    {rankings.catcher.rank <= 3
                      ? getAwardImage(rankings.catcher.rank)
                      : getOrdinalRank(rankings.catcher.rank)}
                  </Col>
                  <Col md="4">
                    Mining:{" "}
                    {rankings.mining.rank <= 3
                      ? getAwardImage(rankings.mining.rank)
                      : getOrdinalRank(rankings.mining.rank)}
                  </Col>
                </Row>
              </div>
            ) : (
              <div style={{ 
                color: "rgba(255, 255, 255, 0.7)",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                borderRadius: "8px",
                padding: "1rem",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}>
                <img src="/loading.gif" alt="Loading..." width="32" /> Loading rankings...
              </div>
            )}
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default PlayerStats;
